import options from './shy.directive';

export default {
    selector: 'imSoShy',
    options
};



// WEBPACK FOOTER //
// ./app/common/shy/index.js